import request from '@/utils/request'

const extraStyleApi = {
  // 查询照片列表
  queryExtraStylePhotoList: (params) => {
    return request({
      url: '/activity/style-photo/query-list',
      method: 'get',
      params
    })
  },
  // 查询榜单
  queryExtraStyleMonthRanking: (params) => {
    return request({
      url: '/activity/style-photo/month-ranking',
      method: 'get',
      params
    })
  },
  // 上传图片
  uploadExtraStylePhoto: (data) => {
    return request({
      url: '/activity/style-photo/upload',
      method: 'post',
      data
    })
  },
  queryExtraStylePhotoDetail: (params) => {
    return request({
      url: '/public/activity/style-photo/info',
      method: 'get',
      params
    })
  },
  supportExtraStylePhoto: (data) => {
    return request({
      url: '/public/activity/style-photo/support',
      method: 'post',
      data
    })
  },
  // 查询用户授权
  queryExtraStyleAuthorize: () => {
    return request({
      url: '/activity/style-photo/authorize/query',
      method: 'get'
    })
  },
  // 保存用户授权
  saveExtraStyleAuthorize: () => {
    return request({
      url: '/activity/style-photo/authorize/save',
      method: 'post'
    })
  }
}

export default extraStyleApi
